import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'

Vue.use(Vuex)

const state = {
  doctors: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalUsers: 0,
    totalPages: 0
  },
  paginationReport: {
    currentPage: 1,
    perPage: 5,
    totalUsers: 0,
    totalPages: 0
  },
  usersCatalog: {},
  filterParams: '',
  isModalVisible: false
}

const mutations = {
  SET_USERS (state, payload) {
    state.doctors = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalUsers: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_REPORT (state, payload) {
    state.report = payload.data.data

    state.paginationReport = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalUsers: payload.total,
      totalPages: payload.last_page
    }
  },
  ADD_USER (state, payload) {
    state.doctors.unshift(payload)
  },
  UPDATE_USER (state, payload) {
    const idx = state.doctors.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.doctors, idx, payload)
    }
  },
  DELETE_USER (state, payload) {
    const idx = state.doctors.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.doctors, idx)
    }
  },
  DELETE_USERS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.doctors.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.doctors, idx)
      }
    }
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.usersCatalog[object] = payload.data
  }
}

const actions = {
  async loadUsers ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`users-doctors?page=${payload.page}${state.filterParams}&type=2`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_USERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionUser ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`users/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_USER', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.users', text: `users.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/doctors/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  }
}

const getters = {
  doctors: state => state.doctors,
  report: state => state.report,
  usersCatalog: state => state.usersCatalog,
  pagination: state => state.pagination,
  paginationReport: state => state.paginationReport,
  isModalVisible: state => state.isModalVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
